import "./InfoSidebar.scss";
import React, { useState } from "react";
import { Button, ButtonType } from "../../Components";
import { MdHelpOutline } from "react-icons/md";
import Tray from "./Tray/Tray";

export interface InfoProps {
  title: string;
  content: string;
}

interface InfoSidebarProps {
  showHelpButton: boolean;
  infoList: InfoProps[];
}

const InfoSidebar: React.FC<InfoSidebarProps> = ({ showHelpButton, infoList }) => {
  const [showTray, setShowTray] = useState<boolean>(false);

  const helpButtonView = (
    <div className="infoButtonContainer">
      <Button
        className="infoPillButton"
        size="lg"
        type={ButtonType.FILLED}
        icon={<MdHelpOutline className="infoButtonQuestionIcon" />}
        title="Help"
        onClick={() => setShowTray(true)}
      />
    </div>
  );

  const trayView = showTray ? (
    <Tray infoList={infoList} setShowExpandedTray={setShowTray}></Tray>
  ) : (
    <div />
  );
  return (
    <div>
      {showHelpButton && helpButtonView}
      {showTray && trayView}
    </div>
  );
};

export default InfoSidebar;
